'use strict';

var React = require('react');

const usePrevious = (value) => {
    const previous = React.useRef(undefined);
    React.useEffect(() => {
        previous.current = value;
    });
    return previous.current;
};

exports.usePrevious = usePrevious;
//# sourceMappingURL=usePrevious.js.map
